import Axios from "axios";
import auth from "./auth";

export const endpointRedirect = "http://api.chordscore.com";
// export const endpointRedirect = "http://127.0.0.1:8000";

export const endpoint = "https://api.chordscore.com/api";
// export const endpoint = "https://api-demo.chordscore.com/api";
// export const endpoint = "http://localhost:8000/api";

// export const endpointRedirect = "http://api-dev.chordscore.com";
// export const endpoint = "https://api-demo.chordscore.com/api";
// export const endpoint = "https://api-dev.chordscore.com/api";

export const api = Axios.create({
    baseURL: endpoint,
    headers: {
        Authorization: `Bearer ${auth.getToken()}`,
    },
});

let refreshing: Promise<boolean> | null = null;

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response.status === 401 && originalRequest.url === `${endpoint}/refresh/token`) {
            window.location.href = "/auth/error";
            return Promise.reject(error);
        }

        // if (localStorage.getItem("retry")) {
        //   localStorage.removeItem("retry");
        //   window.location.href = "/auth/error";
        //   return null;
        // }

        if (error.response.status === 401) {
            localStorage.setItem("retry", "true");
            // 다른 탭·다른 요청이 이미 토큰을 새로 받았으면 그 토큰으로 다시 불러오기만 (갱신 토큰은 한 번 쓰면 무효라 또 갱신하면 실패 → 로그아웃됨)
            const sentToken = String((originalRequest.headers && originalRequest.headers["Authorization"]) || "").replace(/^Bearer\s+/i, "");
            const nowToken = auth.getToken();
            if (nowToken && sentToken && nowToken !== sentToken) {
                return window.location.reload();
            }
            // 401 이 여러 개 한꺼번에 와도 갱신은 한 번만
            if (!refreshing) {
                refreshing = api
                    .post("/refresh/token", {
                        refresh_token: auth.getRefreshToken(),
                    })
                    .then((res) => {
                        if (res.status === 200 && res.data.success) {
                            auth.setToken(res.data.data.access_token);
                            auth.setRefreshToken(res.data.data.refresh_token);
                            api.defaults.headers["Authorization"] =
                                res.data.data.access_token;
                            return true;
                        }
                        return false;
                    })
                    .catch((err) => {
                        console.log(err);
                        return false;
                    });
            }
            return refreshing.then((ok) => {
                if (ok) {
                    window.location.reload();
                } else {
                    window.location.href = "/auth/error";
                }
                return null;
            });
        }

        if ((!localStorage.getItem("rememberMe") || localStorage.getItem("rememberMe") === "false") && error.response.status === 401) {
            window.location.href = "/auth/error";
            return null;
        }

        if(error.response.status === 500) {
            alert('Error 500: ')
            console.log(error);
        }

        if(error.response.status === 404) {
            alert('Error 404 not found ')
            console.log(error);
        }

        return Promise.reject(error);
    }
);
